import React from 'react'
import {   Field} from 'redux-form'
const _ = require('lodash')

var systemWidgetNames=[{
    key:'COUCH_WIDGET',
    value:'COUCH_WIDGET'
    
  },{
    key:'CON_WIDGET',
    value:'CON_WIDGET'
  
   
  }]

const svcomponentInput = ({input, label, type, meta:{error, touched}})=>{
    return(

        <div>
            <label>{label}</label>
            <div>
            <input {...input}  component="input" type="input" placeholder="widgetName" />
            </div>

        </div>
       
    )

}

 export class SVWidComponentEp extends React.Component{
    

    constructor(props){
        super(props)
       
        if(this.props.wids && (this.props.wids.length > 0)){
            systemWidgetNames = this.props.wids
        }
      /*  this.svDDChange = this.svDDChange.bind(this)
        this.svfieldType=  this.props.portType || 'CL_String'
        this.state={
            svfieldType: this.props.portType || 'CL_String'
        }
        this.getCoreComponent = this.getCoreComponent.bind(this)

        */
    }
    componentWillReceiveProps(next){
        console.log(next)

    }

   
    svDDChange(e){
        //this.refs.DropdownList.refs
        //this.refs.DropdownList.refs.inner.handleClick()
        console.log(e)
/*
        //ob.target.value
        if(e.target.value =='string'){
            console.log('sv change action to change class')
           // this.props.initialValues.gene
            this.svfieldType= 'CL_String'
        }else if(e.target.value == 'date'){
            this.svfieldType= 'CL_Date'
        }else if(e.target.value == 'narray'){
            this.svfieldType= 'CL_NArray'    

        }else{
            this.svfieldType= 'CL_Number'
        }

        this.setState({
            svfieldType:this.svfieldType
        })
*/
    }

    render(){
        let me = this
        //  this.props.initialValues.svfieldType= 'CL_String'
        console.log(this.props)

       
        let svWids = [...systemWidgetNames]
        if(this.props.wids && (this.props.wids.length > 0)){
            svWids = this.props.wids
        }
       // const {member, index}= this.props

      const   {fields, meta:{error, submitFailed}} = this.props
      /*
        const svfieldType = this.state.svfieldType
       */

      
        return ( 

            <div>
            <h3 className="svthumb-header">SVMore List of Widgets  <span  onClick={()=>{fields.push({
                widgetType:'SVSYSTEM_WIDGET'
            })}} className="et-icon-plus"> </span>  </h3>
           
                  {/*   
            <button type="button" onClick={()=>{ fields.push({
                widgetType:'SVSYSTEM_WIDGET'
            })}}  className="btn btn-md btn-success" > Add Widget </button>
        */}
             { submitFailed && error && <span>{error} </span>}
            <div className="svflex">
            <a>
                    <div className="tbar"><span> CPUWidget1 </span><span className="et-icon-file-text">  </span> <span className="className=et-minus">  </span> </div>
                    <figure>
    
                        <img width="150px" height="150px" src="./thumb.png" />
                    </figure>
                    <figcaption> System Widget</figcaption>
    
                </a>
    
            {
                  fields.map((member, index) => {

                    let  currrentWidName  =  fields.get(index).widgetName
                    console.log( currrentWidName )
                let svMyWid =  _.findWhere(svWids, {name:currrentWidName})

                  let svWidgetDynaSrc = ""
                  if(svMyWid && (svMyWid.svimageDyna)){
                    svWidgetDynaSrc = svMyWid.svimageDyna
                  }else{
                    //svWidgetDynaSrc ="./thumb.png"
                  }
             /*   let currrentWidName = svWids[0].name
                  */
                    /*  let o = fields.get(index)
                      console.log(o) 
                       {`${member}.widgetName`}
                      */
                     
                      
                     return(
                    <a key={index}>
                        <div className="tbar"><span> Member #{index + 1} </span><span className="et-icon-file-text">  </span> <span  onClick={() => fields.remove(index)} className="et-icon-minus">  </span> </div>
                        <figure>
                        <img width="150px" height="150px" src={svWidgetDynaSrc} />

        {/*  
          <img width="150px" height="150px" src="./thumb.png" />
                           
                            */}
                           
                        </figure>
                        <Field   onChange={me.svDDChange}  component="select"  name={`${member}.widgetName`}  id={`${member}.widgetName`} className="form-control" >
                
                <option value="">Select   </option>
                {
    
            
                    svWids.map(  (o, idx)=>(  <option value={o.value} key={o.key}>{o.key}</option>)
                    
               
            )}
    
            </Field>
            {/*  
             <Field  label="svname" component={svcomponentInput} name={`${member}.widgetName`}  id={`${member}.widgetName`} > </Field> 
            */}
                   
        
                    </a>
                    
                   )})
     
             }
               
    
              
    
        </div>
    
     </div>
         )


    }
}

